module.exports = __webpack_public_path__ + "static/media/ic_info_icon_alert.1af43141.svg";